const USP_FREE_SHIPPING_SECTION_ID = 'usp-free-shipping';
const USP_FREE_SHIPPING_MESSAGE_SELECTOR = '[data-usp-free-shipping-message]';

class UspFreeShipping extends HTMLElement {
  connectedCallback() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.unsubscribeCartUpdate = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
    }
  }

  disconnectedCallback() {
    this.unsubscribeCartUpdate?.();
    this.abortController?.abort();
  }

  /**
   * Re-render the message from the usp-free-shipping section so the rule and money formatting live only in Liquid.
   */
  refresh() {
    this.abortController?.abort();
    this.abortController = new AbortController();

    fetch(`${routes.cart_url}?section_id=${USP_FREE_SHIPPING_SECTION_ID}`, { signal: this.abortController.signal })
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const source = html.querySelector(USP_FREE_SHIPPING_MESSAGE_SELECTOR);
        const target = this.querySelector(USP_FREE_SHIPPING_MESSAGE_SELECTOR);
        if (source && target) target.replaceWith(source);
      })
      .catch((error) => {
        if (error.name !== 'AbortError') console.error(error);
      });
  }
}

if (!customElements.get('usp-free-shipping')) {
  customElements.define('usp-free-shipping', UspFreeShipping);
}
